$(function () {
  // https://github.com/basecamp/trix#observing-editor-changes
  $(document).on("trix-attachment-add", "trix-editor", function(event) {
    if (!event.originalEvent.attachment.file) {
      alert(`
        ローカルに保存した画像を挿入して下さい。
        Google等のクラウドに保存されている画像をコピペした場合、
        画像リンク切れになる可能性があります。
      `);
      this.editor.undo();
    }
  });
});
